import React from 'react';
import usePortal from 'react-cool-portal';
import { Box, BoxProps } from '@apia/theme';
import { useAppSelector } from '../../../../../hooks/hooks';
import useCombinedRefs from '../../../../../hooks/useCombinedRefs';
import useContext from '../../../../../hooks/useContext';
import { getSpecificParent } from '../../../../../utils/dom';
import { DataGridIdentifier } from './context';

const Lock = React.forwardRef<HTMLDivElement, BoxProps>((props, ref) => {
  const innerRef = React.useRef<HTMLDivElement>(null);
  const assignRefs = useCombinedRefs<HTMLDivElement>(
    ref as unknown as React.ForwardedRef<unknown>,
    innerRef,
  );

  const { Portal } = usePortal({
    containerId: 'AppModals',
    defaultShow: true,
    autoRemoveContainer: false,
  });

  const { gridId } = useContext(DataGridIdentifier);

  const isLoading = useAppSelector(
    (global) => global.dataGridSlice[gridId].loading,
  );

  if (!isLoading) return null;

  return (
    <Box
      className="grid__loading"
      sx={{
        opacity: 0.5,
      }}
    >
      {getSpecificParent(
        document.activeElement as HTMLElement,
        (current) => current.id === gridId,
      ) && (
        <Portal>
          <Box />
        </Portal>
      )}
      <Box
        {...props}
        ref={assignRefs}
        tabIndex={0}
        title={window.WAIT_A_SECOND}
      >
        {window.WAIT_A_SECOND}
      </Box>
    </Box>
  );
});

export default Lock;
